import { FxConfigTypes } from "./types/fx-config-types";

export const FxConfig: FxConfigTypes = {
  xxxFeatureToggle: {
    value: "Y",
  },
};
